function alertIcon(type) {
    switch (type) {
        case 'near_completion':
            return '💡';
        default:
            return 'ℹ️';
    }
}

function alertBorderColor(type) {
    switch (type) {
        case 'near_completion':
            return 'border-l-blue-400 bg-blue-50';
        default:
            return 'border-l-gray-400 bg-gray-50';
    }
}

const MAX_ALERTS = 3;

function Alerts({ alerts }) {
    const filteredAlerts = (alerts || []).filter(
        (alert) => alert.type !== 'inactivity',
    );

    if (filteredAlerts.length === 0) {
        return null;
    }

    const visibleAlerts = filteredAlerts.slice(0, MAX_ALERTS);

    return (
        <div className="bg-white border border-gray-300 rounded-lg p-5">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Alerts</h2>
            <div className="space-y-2">
                {visibleAlerts.map((alert, index) => (
                    <div
                        key={index}
                        className={`flex items-center gap-3 p-3 rounded-lg border-l-4 ${alertBorderColor(alert.type)}`}
                    >
                        <span className="text-lg flex-shrink-0">{alertIcon(alert.type)}</span>
                        <p className="text-sm text-gray-700">{alert.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Alerts;
